import React from "react";
import SinglePillarContent from "@/components/nds/windows/pillar/SinglePillarContent";

export default function Pillar2VocationContent({ win }) {
  return <SinglePillarContent pillarId="PILLAR_2_VOCATION" focus={win?.payload?.focus} />;
}
